import React from 'react';

import TotalRate from '../rates/TotalRate.jsx';

const TotalOutcome = ({section, outcome, gridLocalization}) => {
    const outcomeRates = {};

    outcome.get('rates')
        .entrySeq()
        .sortBy((r) => r[0])
        .forEach((r) => {
            outcomeRates[r[0]] = r[1];
        });

    const outcomeCondition = outcome.get('condition');

    const isBlocked = outcome.get('isBlocked');

    const conditionCls = 'out-cond' + (isBlocked ? ' closed' : '');
    const cls = 'out total-match' + (isBlocked ? ' closed' : '');

    const props = {
        section,
        gridLocalization
    };

    return (<span className={cls}>
                    <TotalRate key={outcomeRates[1]} id={outcomeRates[1]} {...props} />
                    <span className={conditionCls}>{`<${outcomeCondition}>`}</span>
                    <TotalRate key={outcomeRates[2]} id={outcomeRates[2]} {...props} />
                </span>);
};

TotalOutcome.propTypes = {
    section: React.PropTypes.string.isRequired,
    outcome: React.PropTypes.object.isRequired,
    gridLocalization: React.PropTypes.object.isRequired
};

export default TotalOutcome;



// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/components/outcomes/TotalOutcome.jsx